import React, { useState, useEffect } from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';
import { AiOutlineClose } from 'react-icons/ai';
import PromoCodeImg from '../../Images/PromoCode.png';
import { useGlobalState } from '../../Contexts/GlobalStateContext';
import { useApi } from "../../Services/api";
import './RatesTable.css';

const RatesTable = () => {
  const [currentPromoCode, setCurrentPromoCode] = useState('');
  const [promoCodeError, setPromoCodeError] = useState('');
  const [applied, setApplied] = useState(false);
  const [ratesData, setRatesData] = useState([]);
  const [currency, setCurrency] = useState("");
  const [promoCodes, setPromoCodes] = useState([]);
  const [loadPromoCodes, setLoadPromoCodes] = useState(false);
  const { tempClientId, setErrorVisible, setErrorMessage } = useGlobalState();
  const api = useApi();

  const calculateRate = (promoCodeList) => {
    let totalDiscount = 1.0;
    for (const promoCode of promoCodeList) {
      let discountRateValue = promoCode.DiscountRate;
      totalDiscount = (Math.round(totalDiscount * discountRateValue * 100) / 100).toFixed(2);
    }

    const updatedRates = ratesData.map(rate => {
      return {
        ...rate,
        NewPrice: (Math.round(rate.Rate * totalDiscount * 100) / 100).toFixed(2)
      };
    });
    setRatesData(updatedRates);
  }

  const getRedeemFunction = async () => {
    try {
      const getRedeemBody = { TempClientId: tempClientId };
      const raw = await api.post(`Client/ClientGetRedeemedPromoCode`, getRedeemBody);
      const getRedeemData = raw.data;
      if (getRedeemData.Success === false) {
        setErrorVisible(true);
        setErrorMessage(getRedeemData.Error);
        return;
      }
      const existingCodes = getRedeemData.ClientPromoCodeList;

      if (existingCodes.length === 0) {
        setPromoCodes([]);
        setApplied(false);
        return;
      }
      calculateRate(existingCodes);
      let promoCodeNames = [];
      for (const promoCode of existingCodes) {
        promoCodeNames.push(promoCode.Code);
      }
      setPromoCodes(promoCodeNames);
      setApplied(true);
    } catch (error) {
      console.log('error:', error);
    }
  }

  const getPromoFunction = async () => {
    try {
      const getPromoPriceBody = { promo: currentPromoCode };
      const getPromoPriceApi = await api.get(`Client/Rate?TempClientId=${tempClientId}`, getPromoPriceBody);

      const updatedRatesData = getPromoPriceApi.data.map(item => {
        return {
          ...item,
          Rate: parseFloat(item.Rate).toFixed(2),
          NewPrice: parseFloat(item.Rate).toFixed(2)
        };
      });
      setRatesData(updatedRatesData);
      setCurrency(getPromoPriceApi.data[0].Currency);

      if (tempClientId) {
        setLoadPromoCodes(true);
      }
    } catch (error) {
      console.log('error:', error);
    }
  }

  useEffect(() => {
    getPromoFunction();
  }, []);

  useEffect(() => {
    getRedeemFunction();
  }, [loadPromoCodes]);

  const handleApply = () => {
    if (currentPromoCode) {
      const redeemPromoCode = async () => {
        const applyBody = {
          TempClientId: tempClientId,
          PromoCode: currentPromoCode,
        };
        try {
          const applyData = await api.post('Client/ClientRedeemPromoCode', applyBody);
          const RedeemData = applyData.data;
          if (!RedeemData.Success) {
            setPromoCodeError('Invalid Promocode');
            return;
          }
          getRedeemFunction();
          setApplied(true);
          setPromoCodeError('');
        } catch (error) {
          console.log('error:', error);
        }
      }
      redeemPromoCode();
      setCurrentPromoCode('');
    }
  };

  const handleRemove = (codeToRemove) => {
    const promoDelete = async () => {
      const promoDeleteBody = {
        TempClientId: tempClientId,
        PromoCode: codeToRemove,
      }
      try {
        const raw = await api.post('Client/ClientDeletePromoCode', promoDeleteBody);
        const promoDeleteData = raw.data;
        if (!promoDeleteData.Success) {
          setErrorVisible(true);
          setErrorMessage(promoDeleteData.Error);
          return;
        }
        getRedeemFunction();
        setApplied(true);
      } catch (error) {
        console.log('error:', error);
      }
    }
    promoDelete();
  };

  return (
    <div>
      <p className="PaymentPage-rates-label">Rates</p>
      <div className="PaymentPage-rates-inner">
        {!applied ? (
          <div>
            {ratesData.map((rate, index) => (
              <div className="PaymentPage-rates-text" key={index}>
                <div>{rate.ProductTitle}</div>
                <div className="PaymentPage-rates-right">
                  <span>{currency}</span><b>${rate.Rate}</b><span>{rate.Unit}</span>
                </div>
              </div>
            ))}

            <InputGroup className='PaymentPage-input-apply-container'>
              <span style={{ height: "60px", width: "83%" }}>
                <Form.Control
                  type="text"
                  placeholder="Optional promo code"
                  value={currentPromoCode}
                  onChange={(e) => {
                    setCurrentPromoCode(e.target.value);
                    setPromoCodeError('');
                  }}
                  className={`PaymentPage-promo-inputBox ${promoCodeError ? 'error' : ''}`}
                />
              </span>
              <span>
                <Button className='PaymentPage-apply-btn' variant="primary" onClick={handleApply}>
                  Apply
                </Button>
              </span>
            </InputGroup>
            {promoCodeError && <div className="invalid-feedback" style={{ display: 'block' }}>{promoCodeError}</div>}
          </div>
        ) : (
          <div>
            <div className="PaymentPage-rates-text">
              <div>Monthly subscription fee (per user)</div>
              <div className="PaymentPage-rates-applied-right" style={{ display: "flex", justifyContent: "center" }}>
                {ratesData[0] && <span className="PaymentPage-secondCol-price"><span>{currency}</span><b>${ratesData[0].Rate}</b><span>{ratesData[0].Unit}</span></span>}
              </div>
            </div>

            {ratesData.slice(1).map((rate, index) => (
              <div className="PaymentPage-rates-text" key={index}>
                <div>{rate.ProductTitle}</div>
                <div className="PaymentPage-rates-applied-right">
                  <span className="PaymentPage-firstCol-price"><span>{currency}</span><span>${rate.Rate}</span></span>
                  <span className="PaymentPage-secondCol-price"><span>{currency}</span><b>${rate.NewPrice}</b><span>{rate.Unit}</span></span>
                </div>
              </div>
            ))}

            <InputGroup className='PaymentPage-input-apply-container'>
              <span style={{ height: "60px", width: "83%" }}>
                <Form.Control
                  type="text"
                  placeholder="Optional promo code"
                  value={currentPromoCode}
                  onChange={(e) => {
                    setCurrentPromoCode(e.target.value);
                    setPromoCodeError('');
                  }}
                  className={`PaymentPage-promo-inputBox ${promoCodeError ? 'error' : ''}`}
                />
              </span>
              <span>
                <Button className='PaymentPage-apply-btn' variant="primary" onClick={handleApply}>
                  Apply
                </Button>
              </span>
            </InputGroup>
            {promoCodeError && <div className="invalid-feedback" style={{ display: 'block' }}>{promoCodeError}</div>}

            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {promoCodes.map((code, index) => (
                <InputGroup key={index} className="PaymentPage-applied-promo-container">
                  <span>
                    <img src={PromoCodeImg} alt="Promo Code" style={{ maxWidth: "26px", width: "1.4vw", minWidth: "20px" }} />
                  </span>
                  <span>{code}</span>
                  <Button className="PaymentPage-promo-close-btn" variant="outline-secondary" onClick={() => handleRemove(code)}>
                    <AiOutlineClose />
                  </Button>
                </InputGroup>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RatesTable;
